import { computed, inject, Injectable, signal } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { PermissionsService } from "app/core/auth/services";
import { switchMap } from "rxjs";
import { buildNavigationMenu } from "../constants";
import { IFuturisticMenu } from "../models";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  private _translocoService = inject(TranslocoService);
  private _permissionsService = inject(PermissionsService);

  private _menu = signal<IFuturisticMenu>({
    futuristic: this._buildMenu(),
  });

  public menu = computed(() => this._menu());

  constructor() {
    // Los títulos del sidebar son texto plano (no reactivo), así que hay que
    // reconstruir el árbol entero cada vez que cambia el idioma activo.
    // selectTranslation() carga el JSON del idioma si todavía no está en cache
    // y recién emite cuando ya está disponible: translate() (síncrono) solo es
    // seguro después de eso, si no devuelve la clave cruda mientras se descarga.
    this._translocoService.langChanges$
      .pipe(switchMap((lang) => this._translocoService.selectTranslation(lang)))
      .subscribe(() => {
        this._menu.set({
          futuristic: this._buildMenu(),
        });
      });
  }

  private _buildMenu() {
    return buildNavigationMenu(
      (key) => this._translocoService.translate(key),
      (permission) => this._permissionsService.has(permission),
    );
  }
}
